import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {Circle, MoreHoriz} from '@mui/icons-material'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {Typography, IconButton, Avatar, Menu, MenuItem} from '@mui/material'
import {Close} from '@mui/icons-material'
import {getInitials, getColorFromName, parseError} from '../../utils/helpers'
import {caregiverApi} from '../../services'
import {format} from 'date-fns'
import {SkeletonContainer, TextSkeleton, AvatarSkeleton} from '../Skeletons'

const NotificationCardsSkeleton = () => (
    <SkeletonContainer>
        {['78%', '62%', '70%', '56%'].map((width, index) => (
            <div key={index}>
                <div className="card">
                    <div className="middle">
                        <AvatarSkeleton size={40} />
                    </div>
                    <div className="right">
                        <div className="right-top">
                            <TextSkeleton width={width} fontSize={16} />
                        </div>
                        <TextSkeleton width="100%" fontSize={14} />
                        <TextSkeleton width="70%" fontSize={14} />
                        <div style={{marginTop: 6}}>
                            <TextSkeleton width={80} fontSize={12} />
                        </div>
                    </div>
                </div>
                <br />
            </div>
        ))}
    </SkeletonContainer>
)

export default ({menuCloseNotifications, items, getNotifications, skeleton = false}) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedRow, setSelectedRow] = useState(null)
    const {setLoading, setMessageBox, branchId} = useGlobalStates()

    const menuOpen = (e, row) => {
        setAnchorEl(e.currentTarget)
        setSelectedRow(row)
    }

    const menuClose = () => {
        setAnchorEl(null)
    }

    const markAsRead = () => {
        menuClose()
        if (branchId) {
            setLoading(true)
            caregiverApi
                .markNotificationRead(branchId, selectedRow?.id)
                .then(() => {
                    setLoading(false)
                    getNotifications(true)
                })
                .catch(error => {
                    setLoading(false)
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })
        }
    }

    const markAllAsRead = () => {
        if (branchId) {
            setLoading(true)
            caregiverApi
                .markAllNotificationsRead(branchId)
                .then(() => {
                    setLoading(false)
                    getNotifications(true)
                })
                .catch(error => {
                    setLoading(false)
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })
        }
    }

    return (
        <div className="container">
            <div className="close">
                <IconButton style={{alignItems: 'right'}} onClick={menuCloseNotifications}>
                    <Close />
                </IconButton>
            </div>
            <div className="title">
                <Typography variant="h5" color="text.primary">
                    Notifications
                </Typography>
                <Typography variant="subtitle1" color="text.primary" className="mark-as-read" onClick={markAllAsRead}>
                    Mark all as read
                </Typography>
            </div>
            <br />
            <div className="cards-container">
                {skeleton && <NotificationCardsSkeleton />}
                {!skeleton &&
                    items?.map((item, index) => (
                        <div key={index}>
                            <div className="card">
                                {!item?.read_at && (
                                    <div className="left">
                                        <Circle color="success" style={{height: '10px', width: '10px'}} />
                                    </div>
                                )}
                                <div className="middle">
                                    {item?.avatar_url ? (
                                        <Avatar src={item?.avatar_url} style={{width: 40, height: 40}} />
                                    ) : (
                                        <Avatar
                                            style={{
                                                backgroundColor: getColorFromName(item?.client_initials?.toUpperCase()),
                                                width: 40,
                                                height: 40,
                                                fontSize: 20,
                                            }}>
                                            {item?.client_initials?.toUpperCase()}
                                        </Avatar>
                                    )}
                                </div>
                                <div className="right">
                                    <div className="right-top">
                                        <Typography variant="h8" color="text.primary" style={{maxWidth: 200}}>
                                            {item?.title}
                                        </Typography>
                                        {!item?.read_at && (
                                            <IconButton onClick={e => menuOpen(e, item)}>
                                                <MoreHoriz />
                                            </IconButton>
                                        )}
                                    </div>
                                    <Typography variant="body2" color="text.primary">
                                        {item?.body}
                                    </Typography>
                                    <div style={{marginTop: 6}}>
                                        <Typography variant="caption" color="text.secondary">
                                            {format(new Date(item?.created_at ?? null), 'MMM dd, yyyy')}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>
                    ))}
            </div>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={menuClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}>
                <div>
                    <MenuItem onClick={markAsRead}>Mark as Read</MenuItem>
                </div>
            </Menu>
        </div>
    )
}
